import { Flex } from 'components/flex';
import { List } from 'components/list';
import { Avatar } from 'components/avatar';
import { formatPrice } from 'utils/helpers';
import { ListCard } from 'components/list-card';
import { ListHeader } from 'components/list-header';

import { ProductSummaryListProps } from './types';

const template = '2fr 1fr 1fr';
const titles = ['Product', 'Quantity', 'Price'];

const exchangeTemplate = '2fr 1fr 1fr 1fr';
const exchangeTitles = [...titles, 'Damaged'];

export const ProductSummaryList = ({
  title,
  values,
  isExchange,
}: ProductSummaryListProps) => {
  const currentTitles = isExchange ? exchangeTitles : titles;
  const currentTemplate = isExchange ? exchangeTemplate : template;

  return (
    <Flex column gap={8}>
      <h4>{title}</h4>

      <List
        count={values?.length}
        mainWrapperStyles={{ padding: 0 }}
        header={
          <ListHeader
            padding="8px"
            titles={currentTitles}
            template={currentTemplate}
          />
        }
      >
        {values?.map((value) => {
          const cardValues = [
            <Flex gap={8} alignItems="center">
              <Avatar url={value.product?.image} />
              <h4>{value?.product?.name}</h4>
            </Flex>,
            value.quantity,
            formatPrice(value.price),
          ];

          if (isExchange) {
            cardValues.push(value.isDamaged ? 'Yes' : 'No');
          }

          return (
            <ListCard
              key={value.id}
              values={cardValues}
              headers={currentTitles}
              template={currentTemplate}
            />
          );
        })}
      </List>
    </Flex>
  );
};
